<template>
  <div class="note mt-4">
    <span class="note-title">Lưu ý:</span>
    <div class="note-content">
      <p class="note-description">
        Quà tặng được ghi nhận theo số điện thoại đăng ký quay thưởng. Khách hàng khi đăng ký học sẽ sử dụng đúng số điện thoại đăng ký quay thưởng để nhận ưu đãi.
      </p>
      <p class="note-description">Ưu đãi được áp dụng duy nhất trong ngày 9h - 22h30 10/06/2024</p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="css" scoped>
  .note {
    display: flex;
    flex-direction: column;
    font-style: italic;
    font-size: 18px;
  }
  .note-title {
    color: #01518E;
    font-weight: 500;
  }
</style>